import Separator from "components/shared/Separator";
import QuestionList from "./QuestionList";
import Feedback from "components/shared/Feedback";
import { Fragment } from "react";
import Heading, { HEADING_TYPES } from "components/shared/Heading";

const Question = ({ module }) => {
	const mainClass = "help-question";
	return module ? (
		<div className={`${mainClass}__container`}>
			{module.name && (
				<Heading
					content={module.name}
					className={`${mainClass}__header`}
					type={HEADING_TYPES.h2}
				/>
			)}
			<Separator />
			<div className={`${mainClass}__info`}>
				{module.question && (
					<div className={`${mainClass}__info--content`}>
						<p
							aria-label={module.question.IndicatorAccessibleText || null}
							className={`${mainClass}__indicator ${mainClass}__indicator--question`}
						>
							{module.question.indicator}
						</p>
						<p
							className={`${mainClass}__text ${mainClass}__text--question`}
							dangerouslySetInnerHTML={{ __html: module.question.text }}
						></p>
					</div>
				)}
				{module.answer && (
					<div className={`${mainClass}__info--content`}>
						<p
							aria-label={module.answer.IndicatorAccessibleText || null}
							className={`${mainClass}__indicator ${mainClass}__indicator--answer`}
						>
							{module.answer.indicator}
						</p>
						<div
							className={`${mainClass}__text ${mainClass}__text--answer`}
							dangerouslySetInnerHTML={{ __html: module.answer.text }}
						></div>
					</div>
				)}
				{module.feedback && <Feedback module={module.feedback} />}
			</div>
			{module.relatedQuestions && (
				<Fragment>
					<Separator />
					<div className={`${mainClass}__related-questions`}>
						<h3 className={`${mainClass}__related-questions-header`}>
							{module.relatedQuestions.name}
						</h3>
						<QuestionList
							questions={module.relatedQuestions.questions}
							modifier={"related-questions"}
						/>
					</div>
				</Fragment>
			)}
		</div>
	) : null;
};

export default Question;
